/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ShoePrintsIconConfig = {
  name: 'ShoePrintsIcon',
  height: 512,
  width: 640,
  svgPath: 'M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ShoePrintsIconConfig);
//# sourceMappingURL=shoe-prints-icon.js.map